import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as MoreIcon } from '@assets/icons/more.svg';

import LoaderComponent from '@components/LoaderComponent';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

const RoleList = ({ search, totalItems }) => {
	const [roleList, setRoleList] = useState([]);
	const [role, setRole] = useState([]);
	const [loading, setLoading] = useState(false);
	const [idToDelete, setIdToDelete] = useState(null);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const navigate = useNavigate();

	const getRoleList = () => {
		setLoading(true);
		ApiClient.GET('getRolesList', '?sort=id,desc&page=0&size=100')
			.then((response) => {
				let data = response.data;
				setRoleList(data);
				setRole(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				toastError('Something went wrong!');
			});
	};

	useEffect(() => {
		getRoleList();
	}, []);

	const onClickDelete = (id) => {
		setIdToDelete(id);
		setShowDeleteModal(true);
	};

	const onDeleteRole = async () => {
		setLoading(true);
		await ApiClient.DELETE('role', {}, `${idToDelete}`)
			.then(({ data }) => {
				setLoading(false);
				let deleteResult = roleList.filter((item) => item.id !== idToDelete);
				setRoleList(deleteResult);
				let deletedRoleResult = role.filter((item) => item.id !== idToDelete);
				setRole(deletedRoleResult);
				setShowDeleteModal(false);
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				setLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	useEffect(() => {
		let searchResult = roleList.filter(
			(item) => item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
		);
		setRoleList(search ? searchResult : role);
	}, [search]);

	useEffect(() => {
		totalItems(`${roleList.length} Roles`);
	}, [roleList]);

	return (
		<LoaderComponent loading={loading}>
			<div className="admin-list-table">
				<table className="table with-border">
					<thead>
						<tr>
							<th className="type-name">Role name</th>
							<th className="created-by">Created by</th>
							<th className="created-at">Created at</th>
							<th className="description">Description</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						{roleList &&
							roleList.map((item, i) => (
								<tr key={i}>
									<td>{item.name}</td>
									<td>{item.createdBy}</td>
									<td>{changeDateFormat(item.createdAt, 'YYYY-MM-DD', 'DD MMM, YYYY')}</td>
									<td>{item.description}</td>
									<td>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle"
													type="button"
													id="menu1"
													data-toggle="dropdown"
													aria-expanded="true"
												>
													<MoreIcon />
												</button>
												<ul
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													aria-labelledby="menu1"
													x-placement="bottom-end"
												>
													<li role="presentation" className="px-4 pb-3 pt-3">
														<span
															className="font-weight-normal  text-black cursor-pointer"
															onClick={() => navigate('/roles/edit/' + item.id)}
														>
															Edit
														</span>
													</li>
													<li role="presentation" className="px-4 pb-3">
														<span
															className="font-weight-normal  text-black cursor-pointer"
															onClick={() => onClickDelete(item.id)}
														>
															Delete
														</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
								</tr>
							))}
					</tbody>
				</table>
				{roleList.length === 0 && <NoData message={'No result found'} />}

				<Modal
					show={showDeleteModal}
					onHide={() => setShowDeleteModal(false)}
					dialogClassName="modal-90w role-modal"
					aria-labelledby="example-custom-modal-styling-title"
				>
					<Modal.Header closeButton>
						<Modal.Title id="example-custom-modal-styling-title">Delete role</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="container">
							<div className="section-content">
								<br />
								<br />
								<div className="form-row role-delete-modalbox">
									<div className="">
										<button
											type="submit"
											className="button tertiary size32"
											onClick={() => onDeleteRole()}
										>
											Confirm
										</button>
									</div>
									<div className="ml-2">
										<button
											type="submit"
											className="button gray-outline size32"
											onClick={() => setShowDeleteModal(false)}
										>
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		</LoaderComponent>
	);
};

export default RoleList;
